import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { archiveTopicCache } from '../utilities/cache';
import { ARCHIVE_TOPIC } from '../utilities/mutations';
import { useSpaceContext } from '../contexts/space';

const ArchiveTopicModal = ({ topicId, spaceSlug, onClose }) => {
  const navigate = useNavigate();
  const { spaceVars } = useSpaceContext();
  const [archiveTopic] = useMutation(ARCHIVE_TOPIC, {
    variables: { id: topicId },
    update: (cache, { data: { archiveTopic } }) =>
      archiveTopicCache(spaceVars, spaceSlug, cache, archiveTopic),
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Archive topic</ModalName>
      <ModalPart>Are you sure you want to archive this topic?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          data-autofocus
          onClick={() => {
            archiveTopic();
            if (onClose) {
              onClose();
            }
            navigate(`/s/${spaceSlug}`);
          }}
          isDanger
          isExtended
        >
          Archive
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default ArchiveTopicModal;
